import _ from 'lodash';

export const stringifyGeoJSON = (obj, replacer, indent) => {
    const printOnceReplacer = (key, value) => {
        // browsers will not print more than 20K, I don't see the point to allow 2K.. algorithm will not be fast anyway if we have too many objects
        if (printedObjects.length > 2000) {
            return 'object too long';
        }

        let printedObjIndex = false;
        printedObjects.forEach((o, index) => {
            if (o === value) {
                printedObjIndex = index;
            }
        });

        if (!key) {
            printedObjects.push(obj);
            printedObjectKeys.push('root');
            return value;
        } else if (String(printedObjIndex) !== 'false' && _.isObject(value)) {
            if (printedObjectKeys[printedObjIndex] === 'root') {
                return '(pointer to root)';
            } else {
                return `(see ${(!!value && !!value.constructor) ? value.constructor.name.toLowerCase() : typeof (value)} with key ${printedObjectKeys[printedObjIndex]})`;
            }
        } else {
            const qualifiedKey = key || '(empty key)';
            printedObjects.push(value);
            printedObjectKeys.push(qualifiedKey);
            if (replacer) {
                return replacer(key, value);
            } else {
                return value;
            }
        }
    };

    let printedObjects = [];
    let printedObjectKeys = [];
    return JSON.stringify(obj, printOnceReplacer, indent);
};



// WEBPACK FOOTER //
// ./src/scripts/api/utils.js